export default __webpack_public_path__ + "eacffd0db0d516f759a0d5b6ac40ae99.png";